import { render, staticRenderFns } from "./wsUserEditDialog.vue?vue&type=template&id=bd7bbb84&scoped=true&"
import script from "./wsUserEditDialog.vue?vue&type=script&lang=js&"
export * from "./wsUserEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7bbb84",
  null
  
)

export default component.exports